// extracted by mini-css-extract-plugin
export var desktopHeadline = "navigation-item-dr-module--desktopHeadline--6f63b";
export var desktopItems = "navigation-item-dr-module--desktop-items--8e59c";
export var mobileHeadline = "navigation-item-dr-module--mobileHeadline--81142";
export var mobileLinks = "navigation-item-dr-module--mobile-links--6ab81";
export var navigationItem = "navigation-item-dr-module--navigation-item--b945b";
export var navigationItemActive = "navigation-item-dr-module--navigation-item-active--d2e2e";
export var navigationItemHeadline = "navigation-item-dr-module--navigation-item-headline--68ed0";
export var navigationItemLinks = "navigation-item-dr-module--navigation-item-links--eaae3";
export var navigationItemOne = "navigation-item-dr-module--navigation-item-one--cbebe";
export var navigationItemTop = "navigation-item-dr-module--navigation-item-top--ca0f4";
export var navigationItemTwo = "navigation-item-dr-module--navigation-item-two--29891";
export var navigationItemWrapper = "navigation-item-dr-module--navigation-item-wrapper--716d0";
export var navigationItems = "navigation-item-dr-module--navigation-items--0913b";
export var navigationLinkHeadline = "navigation-item-dr-module--navigation-link-headline--b66b5";